import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useAuthStore = defineStore('auth', () => {
  // State
  const token = ref(localStorage.getItem('token'));
  const userRole = ref(localStorage.getItem('userRole'));
  const userId = ref(localStorage.getItem('userId'));

  // Getters
  const isLoggedIn = computed(() => !!token.value);
  const currentRole = computed(() => userRole.value);

  // Actions
  const login = (newToken, user) => {
    token.value = newToken;
    userRole.value = user.role;
    userId.value = user.id;
    localStorage.setItem('token', newToken);
    localStorage.setItem('userRole', user.role);
    localStorage.setItem('userId', user.id);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userId');
    token.value = null;
    userRole.value = null;
  };

  return {
    token,
    isLoggedIn,
    currentRole,
    login,
    logout,
  };
});